<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('esl_attendance_admin')"
                    :isColumns="false"
                    :isFilter="false"
            >
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('esl_attendance_admin')"
                          :isColumns="false"
                          :isFilter="false"
            >
            </HeaderMobile>
        </template>
        <div>
            <b-col v-if="!students.length && !isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                <div class="d-flex flex-column align-items-center">
                    <i class="ri-information-line" style="font-size: 100px">
                    </i>
                    <p>
                        {{$t('Student Not Found')}}
                    </p>
                </div>
            </b-col>
            <b-col v-else-if="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                <b-spinner variant="primary" label="Loading..."></b-spinner>
            </b-col>
            <div v-else>
                <div class="d-flex  flex-column">
                    <div class="d-flex justify-content-start overflow-auto">
                        <div>
                            <b-table
                                responsive
                                bordered
                                :items="[sectionInformation]"
                                :fields="fields"
                                class="border "
                            ></b-table>
                        </div>
                    </div>
                </div>
                <b-col class="d-flex flex-column flex-md-row align-items-center justify-content-center  p-3 p-md-5 gap-2 gap-md-3">
                    <h6 class="mb-0">Week</h6>
                    <b-col cols="auto" class="px-4">
                        <b-form-select
                            v-model="week"
                            @change="onChangeWeek"
                            :options="weekOptions"
                            style="min-width: 75px;"
                            size="sm"
                        ></b-form-select>
                    </b-col>
                    <h6 class="mb-0">Days</h6>
                    <b-col cols="auto" class="px-1">
                        <b-form-select
                            v-model="absenceEntryDate"
                            @change="onChangeDays"
                            :options="absenceEntryDates"
                            style="min-width: 100px;"
                            size="sm"
                        ></b-form-select>
                    </b-col>
                </b-col>
                <div  class="overflow-auto">
                <b-table-simple style="width:100%"  bordered >
                    <thead>
                    <tr>
                        <th rowspan="2" class="text-center justify-center width-40">#</th>
                        <th rowspan="2" class="text-center justify-center width-100">ID#</th>
                        <th rowspan="2" class="text-center justify-center width-120">Picture</th>
                        <th rowspan="2" class="text-center justify-center">First Name</th>
                        <th rowspan="2" class="text-center justify-center">Last Name</th>
                        <th :colspan="hoursInDay" class="border-bottom text-center" >
                            <div class="d-flex flex-column align-items-center mb-2">
                                <span >{{ weekDaysOptions[absenceEntryDate]?.name }} ({{ weekDaysOptions[absenceEntryDate]?.date }})</span>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <template>
                            <th v-for="(i,key) in hoursInDay" :key="'lesson-' + '-' + i" class="height-100">
                                <div class="d-flex justify-content-center align-items-center">

                                    <b-form-checkbox
                                        v-if="weekDaysOptions[absenceEntryDate]?.lessons[key]"
                                        :id="'checkbox-' + weekDaysOptions[absenceEntryDate]?.date + '-' + i"
                                        v-model="weekDaysOptions[absenceEntryDate].lessons[key].isDisabled"
                                        @change="handleSelectedHours(weekDaysOptions[absenceEntryDate]?.lessons?.[key],weekDaysOptions[absenceEntryDate])"
                                    >

                                    </b-form-checkbox>
                                    <span>{{weekDaysOptions[absenceEntryDate]?.lessons[key].name}}</span>
                                </div>


                            </th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(student, index) in students" :key="student.id" class="align-middle text-center">
                        <td class="text-center justify-center">{{ index + 1 }}</td>
                        <td class="text-center justify-center">{{ student.student_number }}</td>
                        <td>
                            <b-img :src="student.photo ? student.photo : require('@/assets/img/no-photo.jpg')"  thumbnail style="max-width: 130px" ></b-img>
                        </td>
                        <td class="text-left">{{ student.name }}</td>
                        <td class="text-left">{{student.surname}}</td>
                        <template >
                            <td v-for="(i,key) in hoursInDay" :key="'attendance-' + student.student_program_id + '-' + i + '-' + index" class="text-left">

                                    <b-form-checkbox value="D" v-model="selectedAttendance[absenceEntryDate][i][index].status"
                                                     :key="'rd-' + student.student_program_id + '-' + i + '-' + index"
                                                     :disabled="!weekDaysOptions[absenceEntryDate]?.lessons[key].isDisabled"
                                                     v-if="selectedAttendance[absenceEntryDate] &&
                                                            selectedAttendance[absenceEntryDate][i] &&
                                                            selectedAttendance[absenceEntryDate][i][index]">Doctor's Note</b-form-checkbox>
                                    <b-form-checkbox value="E" v-model="selectedAttendance[absenceEntryDate][i][index].status"
                                                     :key="'re-' + student.student_program_id + '-' + i + '-' + index"
                                                     :disabled="!weekDaysOptions[absenceEntryDate]?.lessons[key].isDisabled"
                                                     v-if="selectedAttendance[absenceEntryDate] &&
                                                            selectedAttendance[absenceEntryDate][i] &&
                                                            selectedAttendance[absenceEntryDate][i][index]">Excused</b-form-checkbox>
                                    <b-form-checkbox value="O" v-model="selectedAttendance[absenceEntryDate][i][index].status"
                                                     :key="'ro-' + student.student_program_id + '-' + i + '-' + index"
                                                     :disabled="!weekDaysOptions[absenceEntryDate]?.lessons[key].isDisabled"
                                                     v-if="selectedAttendance[absenceEntryDate] &&
                                                            selectedAttendance[absenceEntryDate][i] &&
                                                            selectedAttendance[absenceEntryDate][i][index]">Out of Country</b-form-checkbox>
                                    <div class="mt-2" v-if="selectedAttendance[absenceEntryDate][i][index].status && !['D','E','O'].includes(selectedAttendance[absenceEntryDate][i][index].status)">
                                        {{ attendanceValues[selectedAttendance[absenceEntryDate][i][index].status] }}
                                    </div>
                                    <div class="badge badge-info mt-3" v-if="selectedAttendance[absenceEntryDate][i][index].updated_at">
                                        {{selectedAttendance[absenceEntryDate][i][index].updated_at}}
                                    </div>
                            </td>
                        </template>
                    </tr>
                    </tbody>
                    <b-tfoot>
                        <tr class="border">
                            <td colspan="5"></td>
                            <template>
                                <td v-for="(i,key) in hoursInDay" :key="'save-button-' + weekDaysOptions[absenceEntryDate]?.date + '-' + i" class="text-center">
                                    <b-button
                                        v-if="weekDaysOptions[absenceEntryDate]?.lessons[key].isDisabled"
                                        variant="success"
                                        size="sm"
                                        block
                                        @click="saveAttendance(weekDaysOptions[absenceEntryDate], i,key)"
                                    >
                                        Save
                                    </b-button>
                                </td>
                            </template>
                        </tr>
                    </b-tfoot>

                </b-table-simple>
                </div>
            </div>

        </div>
    </app-layout>


</template>

<script>

import EslAttendanceService from "@/services/EslAttendanceService";
import EslInstructorService from "@/services/EslInstructorService";
import moment from 'moment';
import qs from "qs";
import showErrors from "@/helpers/showErrors";
export default {
    data() {
        return {
            instructorId: null,
            week: 1,
            attendances1: null,
            selectedAttendance: {},
            selectedLessons: [],
            students: [],
            attendance: {},
            weeks: [],
            activeWeek: null,
            hoursInDay: null,
            weekDaysOptions: [],
            selectedHours: [],
            absenceEntryDate:null,
            isWeekDayOptionSelected: false,
            isLoading:false,
            attendanceValues:{'P':"Present", 'L':"Late", 'A':"Absent"},
            sectionInformation:null,
            fields: [
                {
                    key: 'course_name',
                    label:this.$t('course_name'),
                },
                {
                    key: 'classroom_name',
                    label: this.$t('classroom'),
                },
                {
                    key: 'instructor_name',
                    label: this.$t('instructor_name'),
                },
                {
                    key: 'start_date',
                    label: this.$t('start_date'),
                },
                {
                    key: 'end_date',
                    label: this.$t('end_date'),
                },

            ],
        };
    },
    metaInfo() {
        return {
            title: this.$t('esl_attendance_admin'),
        }
    },
    computed: {
        weekOptions() {
            return this.weeks.map((_, index) => ({
                text: index + 1,
                value: index + 1,
            }));
        },
        absenceEntryDates() {
            const options = []
            if (Object.entries(this.weekDaysOptions).length > 0) {
                Object.entries(this.weekDaysOptions).forEach(([key, value]) => {
                    options.push({
                        text: value.name + ' ' +'('+ value.date +')',
                        value:value.fullYear
                    })
                })
            }
            return  options
        }
    },
    created() {
        this.getStudents(true);
    },

    methods: {
        async getWeekOptions() {
            const dayArrays = this.activeWeek.days.map(item => {
                const date = new Date(item);
                const daysObject = {
                    name: moment(date).locale('en').format('dddd'),
                    date: date.toLocaleDateString("en-US", { month: "short", day: "2-digit" }),
                    fullYear: moment(date).format('MM/DD/YYYY'),
                    disabled: false,
                    unchangedDate: date,
                    lessons: Array.from({ length: this.hoursInDay }, (_, j) => ({
                        name: `Lesson ${j + 1}`,
                        isDisabled: false,
                    }))
                };
                return daysObject;
            }).sort((a, b) => a.unchangedDate - b.unchangedDate);

            const newObject={}
            dayArrays.forEach(day => {
                this.$set(newObject,day.fullYear,day)
            })

            this.absenceEntryDate=dayArrays[0].fullYear

            this.weekDaysOptions = newObject;

        },
        async getActiveWeek(weeks) {
            let week = weeks.find(item => item.is_active);
            if(!week) {
                week = weeks[0];
            }
            return week;
        },
        async getStudents(isActiveWeek = false) {
            this.isLoading = true;
            const config = {
                params: {
                    filter: {
                        id: this.$route.params.sessionId,
                    }
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            const {id} =localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):null;

            const [attendanceConfigData, studentList] = await Promise.all([
                EslInstructorService.getInstructorSession(id, config),
                EslAttendanceService.getStudentsInformation(this.$route.params.sessionId)
            ]);
            this.weeks = attendanceConfigData.data.data[0].weeks;
            this.sectionInformation = attendanceConfigData.data.data[0];
            this.hoursInDay = attendanceConfigData.data.data[0].hours_in_a_day;
            this.students = studentList.data.data;
            const requestWeek = isActiveWeek ? (this.activeWeek = await this.getActiveWeek(this.weeks), this.week = this.activeWeek.week, this.activeWeek.week) : this.week;
            if (!this.isWeekDayOptionSelected) {
                await this.getWeekOptions();
            }
            const studentAttendance = await EslInstructorService.getWeeksInformation(this.$route.params.sessionId, requestWeek);
            if (studentAttendance.data.success) {
                this.initializeAttendance(studentAttendance.data.data);
            } else {
                this.initializeAttendance();
            }
            this.isLoading = false;
        },
        initializeAttendance(selectedAttendance = null) {
            if (!this.weekDaysOptions || !this.hoursInDay || !this.students) return;
            Object.entries(this.weekDaysOptions).forEach(([key, value]) => {
                this.$set(this.selectedAttendance, value.fullYear, {});
                for (let i = 1; i <= this.hoursInDay; i++) {
                    this.$set(this.selectedAttendance[value.fullYear], i, this.students.map(student => ({
                        student_program_id: student.student_program_id,
                        status: null
                    })));
                }
            })
            if (selectedAttendance) {
                Object.entries(selectedAttendance).forEach(([date, hours]) => {
                    if (this.selectedAttendance[date]) {
                        Object.entries(hours).forEach(([hour, entries]) => {
                            if (this.selectedAttendance[date][hour]) {
                                entries.forEach(newEntry => {
                                    const index = this.selectedAttendance[date][hour].findIndex(
                                        entry => entry.student_program_id === newEntry.student_program_id
                                    );
                                    if (index !== -1) {
                                        this.selectedAttendance[date][hour][index] = newEntry;
                                    } else {
                                        this.selectedAttendance[date][hour].push(newEntry);
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },
        handleSelectedHours(day,lesson) {
            let count = 0;
            Object.entries(this.weekDaysOptions).forEach(([key, value]) => {
                value.lessons.forEach(lesson => {
                    if (lesson.isDisabled && count > 0) {
                        lesson.isDisabled = false;
                    } else if (lesson.isDisabled) {
                        count += 1;
                    }
                });
            })
        },
        async saveAttendance(day, hour, lessonKey) {
            if (!this.checkPermission('eslattendance_store')) return this.$toast.error('unauthorized_operation');

            const formData = {
                date: day.fullYear,
                hour: hour,
                session_id: Number(this.$route.params.sessionId),
                esl_attendances: this.selectedAttendance[day.fullYear][hour]
            };

            try {
                const res = await EslInstructorService.saveAttendanceAdmin(formData);
                this.$toast.success(this.$t("api." + res.data.message));
                this.isWeekDayOptionSelected=true
                await this.getStudents();
            } catch (error) {
                showErrors(error);
            }finally {
                this.absenceEntryDate=day.fullYear;
            }
        },
       async onChangeWeek(value) {
           this.activeWeek = this.weeks[value - 1];
           await this.getStudents()
        },
        async onChangeDays(value) {
            Object.entries(this.weekDaysOptions).forEach(([key, value]) => {
                value.lessons.forEach(lesson => {
                    lesson.isDisabled = false;

                });
            })
        },
        changeAttendanceStatus(key) {
            let newAttendance = []
            this.selectedAttendance[this.absenceEntryDate][key+1].forEach((item)=>{
                newAttendance.push({
                    status: 'P',
                    student_program_id: item.student_program_id,
                })
            })
            this.selectedAttendance[this.absenceEntryDate][key+1] = newAttendance;
        }
    },
    watch:{
        week(newVal,oldVal){
            if (newVal!==oldVal) {
                this.isWeekDayOptionSelected=false
            }
        }
    }
};
</script>
